// JSON LD schema for google search results.
export const FAQ_SCHEMA = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  "mainEntity": [
    {
      "@type": "Question",
      "name": "How do I sell tickets on StubHub?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "<div><b>It's easy!</b> <ol><li>Sign in or create a StubHub account to get started selling tickets.</li><li>Include the number of tickets you're selling, the seats, and delivery details in your listing.</li><li>Set your price and wait for the buyers to come to you!.</li></ol></div>"
      }
    },
    {
      "@type": "Question",
      "name": "How can I sell concert tickets on StubHub?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "<div><b>We've made it impossibly easy to list your tickets on StubHub.</b>Thanks to our massive catalog of events, you can sell tickets to almost any event in just three steps! Just sign in, tell us what concert tickets you're selling, and set your price.</div>"
      }
    },
    {
      "@type": "Question",
      "name": "How can I sell mobile tickets on StubHub?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "<div><b>Listing on StubHub is as easy as 1-2-3</b>. Just sign in to the app or on your mobile browser, tell us what tickets you're selling, and set your price. When you have a buyer, we'll give you the added benefit of providing instructions on how to deliver the tickets to them.</div>"
      }
    },
    {
      "@type": "Question",
      "name": "What options do I have to deliver tickets I sell on StubHub?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "<ul><li><b>Mobile transfer</b>: Tickets are in the online account where you bought them (the team, Ticketmaster, etc.)</li><li><b>Flash Seats</b>: Mobile-only tickets stored in a Flash Seats (AXS) account.</li><li><b>Barcode</b>: Tickets that use barcodes to validate. Enter the barcode on your tickets to deliver them.</li><li><b>Paper tickets</b>: Traditionally-printed tickets, wristbands, or tickets printed at home.</li><li><b>PDF tickets</b>: Original .PDF files on your computer or mobile device.</li><li><b>Pickup tickets</b>: Hard tickets you can deliver to one of our Last Minute Services (LMS) location.</li></ul>"
      }
    }
  ]
};
